import { CountUp } from 'countup.js';

window.onload = function () {
  var options = {
    useEasing: true,
    useGrouping: true,
    separator: ',',
    decimal: '.',
    prefix: '',
    suffix: '',
    enableScrollSpy: true
  };


  const countElements = document.querySelectorAll(".info-values strong") as NodeListOf<HTMLElement>;
  if (countElements.length === 0) return;
  countElements.forEach(countElement => {
    const countElementValue = parseInt(countElement.innerText as string);
    const count = new CountUp(countElement, countElementValue, options);
    count.start();
  });
}